// JsFromRoutes CacheKey 1a60b2ed8cf26cca6a0062910dce08a8
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  list: definePathHelper('get', '/template_packs/start'),
}
